import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table table-sm" }
const _hoisted_2 = {
  key: 0,
  style: {"width":"30%"}
}
const _hoisted_3 = {
  key: 1,
  style: {"width":"40%"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("col", { style: {"width":"10%"} }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-end"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "small text-muted" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "text-end"
}
const _hoisted_17 = {
  type: "button",
  class: "btn btn-link text-dark"
}
const _hoisted_18 = { class: "dropdown-menu show" }
const _hoisted_19 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_20 = {
  key: 1,
  class: "dropdown-item text-muted"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { class: "pt-2 px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_VRuntimeTemplate = _resolveComponent("VRuntimeTemplate")!
  const _component_DropdownPopper = _resolveComponent("DropdownPopper")!
  const _component_ItemConfiguredOptions = _resolveComponent("ItemConfiguredOptions")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("colgroup", null, [
      (_ctx.allCatalogs)
        ? (_openBlock(), _createElementBlock("col", _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.allCatalogs)
        ? (_openBlock(), _createElementBlock("col", _hoisted_3))
        : _createCommentVNode("", true),
      _hoisted_4,
      _hoisted_5,
      (_ctx.actionsEnabled)
        ? (_openBlock(), _createElementBlock("col", _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("thead", null, [
      _createElementVNode("tr", _hoisted_7, [
        (_ctx.allCatalogs)
          ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('CatalogCode')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.allCatalogs)
          ? (_openBlock(), _createElementBlock("th", _hoisted_9, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('Description')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("th", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.t('Quantity')), 1)
        ]),
        _createElementVNode("th", null, [
          _createElementVNode("small", null, _toDisplayString(_ctx.t('UnitOfMeasure')), 1)
        ]),
        (_ctx.actionsEnabled)
          ? (_openBlock(), _createElementBlock("th", _hoisted_10, [
              _createElementVNode("small", null, _toDisplayString(_ctx.t('Actions')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.catalogs, (cat) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: cat.code + cat.owner
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cat.quantities, (qty) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: qty.quantityId
            }, [
              _createElementVNode("tr", {
                class: _normalizeClass({
              'no-border-bottom': qty.configurationIds && qty.configurationIds.length,
            })
              }, [
                (_ctx.allCatalogs)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _withModifiers(($event: any) => (_ctx.details(cat.id)), ["prevent"])
                        }, _toDisplayString(cat.code), 9, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(cat.owner.userId), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.allCatalogs)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                      _createElementVNode("div", null, _toDisplayString(cat.description), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(qty.value), 1),
                _createElementVNode("td", null, _toDisplayString(qty.unitOfMeasure), 1),
                (_ctx.actionsEnabled && _ctx.catalogProductItemMenu?.items?.length)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                      _createVNode(_component_DropdownPopper, {
                        placement: "bottom-start",
                        interactive: true,
                        class: "d-inline-block"
                      }, {
                        trigger: _withCtx(() => [
                          _createElementVNode("button", _hoisted_17, [
                            _createVNode(_component_Icon, { glyph: "menu" })
                          ])
                        ]),
                        dropdown: _withCtx(({ close }) => [
                          _createElementVNode("ul", _hoisted_18, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productItemMenuItems(_ctx.item), (menuItem, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                (menuItem.text === '-')
                                  ? (_openBlock(), _createElementBlock("hr", _hoisted_19))
                                  : (_ctx.isDisabled(menuItem, _ctx.item))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                        (menuItem.itemTemplate)
                                          ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                              key: 0,
                                              template: menuItem.itemTemplate,
                                              "template-props": { instance: _ctx.instance, item: _ctx.item, emit: _ctx.emit, t: _ctx.t }
                                            }, null, 8, ["template", "template-props"]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(menuItem.text), 1)
                                            ], 64))
                                      ]))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        class: "dropdown-item",
                                        href: "",
                                        onClick: _withModifiers(($event: any) => {
                          _ctx.onProductItemMenuAction(menuItem, _ctx.item, cat.id);
                          close();
                        }, ["prevent"])
                                      }, [
                                        (menuItem.itemTemplate)
                                          ? (_openBlock(), _createBlock(_component_VRuntimeTemplate, {
                                              key: 0,
                                              template: menuItem.itemTemplate,
                                              "template-props": { instance: _ctx.instance, item: _ctx.item, emit: _ctx.emit, t: _ctx.t }
                                            }, null, 8, ["template", "template-props"]))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(menuItem.text), 1)
                                            ], 64))
                                      ], 8, _hoisted_21))
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (qty.configurationIds && qty.configurationIds.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                    _createElementVNode("td", {
                      colspan: _ctx.allCatalogs ? 5 : 3
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ItemConfiguredOptions, {
                          "instance-id": _ctx.instanceId,
                          catalog: cat,
                          qty: qty,
                          t: _ctx.t
                        }, null, 8, ["instance-id", "catalog", "qty", "t"])
                      ])
                    ], 8, _hoisted_23)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128))
    ])
  ]))
}